import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import { useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';
import styles from './index.module.scss';
import EfTab from 'elem/ui/ef-tab';
import { useState, useEffect } from 'react';

export default function TabSupport({ theme }: { theme: any }) {
    const { productPageData } = useProductStore();
    const { supportDataArr } = productPageData;
    const [supportData, setSupportData] = useState(null);
    const [spuId, setSpuId] = useState('');
    const [top, setTop] = useState(0);

    const handleTabChange = (tab: any, k: number) => {
        setSupportData(supportDataArr[k]?.supportData);
        setSpuId(tab?.type);
    };

    const renderFrostNav = () => {
        let initScrollTop = 0;
        const regionPopupEl = document.querySelector('.regionPopup') as HTMLElement;
        if (regionPopupEl) {
            const styles = window.getComputedStyle(regionPopupEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? regionPopupEl?.offsetHeight : 0) || 0;
        }
        const headerEl = document.querySelector('.ecoflow-frame-header') as HTMLElement;
        if (headerEl) {
            const styles = window.getComputedStyle(headerEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? headerEl?.offsetHeight : 0) || 0;
        }
        const naverEl = document.querySelector('.ef-nav-product') as HTMLElement;
        if (naverEl) {
            const styles = window.getComputedStyle(naverEl);
            const position = styles.position;
            initScrollTop += Number(position === 'sticky' ? naverEl?.offsetHeight : 0) || 0;
        }
        setTop(initScrollTop);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const tabWrapper = document.querySelector('.product-item-tab .tab-sticky-box') as HTMLElement;
        tabWrapper?.classList.toggle('frost', scrollTop > initScrollTop);
    };

    useEffect(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > 0) {
            document.querySelector('.product-item-tab .tab-sticky-box')?.classList.add('frost');
        }
        document.addEventListener('scroll', renderFrostNav);

        return () => {
            document.removeEventListener('scroll', renderFrostNav);
        };
    }, []);

    useEffect(() => {
        if (supportDataArr?.length > 0) {
            setSupportData(supportDataArr[0]?.supportData);
            setSpuId(supportDataArr[0]?.prodectDetail?.sourceId);
        }
    }, [supportDataArr]);

    return (
        <div className={styles.support}>
            <GetProductData />
            {supportDataArr?.length > 0 && (
                <>
                    {supportDataArr?.length > 1 && (
                        <div className="tab-sticky-box" style={{ top: top + 'px' }}>
                            <div className="tab-wrapper">
                                <EfTab
                                    items={supportDataArr?.map((data: any) => ({ type: data?.prodectDetail?.sourceId, title: data?.prodectDetail?.name }))}
                                    activeType={supportDataArr[0]?.prodectDetail?.sourceId}
                                    onChange={handleTabChange}
                                />
                            </div>
                        </div>
                    )}
                    {supportData && spuId && <ProductSupport supportData={supportData} theme={theme} spuId={spuId} />}
                </>
            )}
        </div>
    );
}
